// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JMbfY6eXSdkicOj1fn3i{flex-direction:column;height:100%;display:flex}.nrcFR308yq87MdrM9HUw{border-radius:0 0 8px 8px;height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `JMbfY6eXSdkicOj1fn3i`,
	"iframeWrapper": `nrcFR308yq87MdrM9HUw`
};
export default ___CSS_LOADER_EXPORT___;
